import React, { useEffect, useState, useRef } from "react";
import L from "leaflet"; // Import Leaflet library
import "leaflet/dist/leaflet.css"; // Import Leaflet CSS
import { loadFloorOnMapHook } from "src/apis/Archilogic";
import "src/pages/BuildingDetail/BuildingDetail.css";
import AlisDialog from "src/components/GenericDialog/GenericDialog";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {
  useNavigate,
  useRouteLoaderData,
  defer,
  Await,
} from "react-router-dom";
const ArchilogicMapComponent = ({ buildingAssets }) => {
  const navigate = useNavigate();
  const publishableToken = "f4ced150-d3c4-46a3-9573-832c69eac4b1";
  const floorId = "86bf18d3-0ae9-4608-85f8-8dcebc95ab14";
  const [map, setMap] = useState(null);
  const ViewMoreDetails = (id) => {
    navigate(`asset/${id}`);
  };

  {
    /**state to allow map initiliazation only once   */
  }
  const [mapInitialized, setMapInitialized] = useState(false);

  {
    /**state control for toggling full screen   */
  }
  const [isFullScreen, setIsFullScreen] = useState(false);

  {
    /** state for storing the asset that was clicked on the archilogic polygon within the map */
  }
  const [archilogDialogData, setArchilogicDialogData] = useState(null);

  {
    /**state to show dialog  with asset data (archilogDialogData) after click on map */
  }
  const [showArchilogDialog, setShowArchilogicDialog] = useState(false);

  {
    /**function for toogling map full screen  */
  }
  const toggleFullScreen = () => {
    setIsFullScreen((prevState) => !prevState);
  };

  {
    /**callback function that makes the asset that is  clicked within the  map to be set in the state (archilogDialogData) **/
  }
  const displayAssetOnArchilogic = (assetInfo) => {
    console.log("asset info structure : ", assetInfo);

    setArchilogicDialogData(assetInfo);
    setShowArchilogicDialog(true);
  };
  {
    /**callback function that allows to close the dialog */
  }
  const CloseArchilogicDialog = () => {
    setShowArchilogicDialog(!showArchilogDialog);
  };

  useEffect(() => {
    var imageCenter = [41.91277786052955, 12.57372781634331]; //make dynamic later on
    if (mapInitialized === false) {
      //this allows to only initialize the map once or else it goes into error
      setMap(
        L.map("map", {
          center: imageCenter,
          zoom: 3,
        })
      );
      setMapInitialized(true);
    }
    if (map && buildingAssets) {
      loadFloorOnMapHook(
        floorId,
        publishableToken,
        buildingAssets,
        displayAssetOnArchilogic,
        map
      );
    }
  }, [map, mapInitialized, buildingAssets]); 

  return (
    <>
      <div
        className={`${
          isFullScreen
            ? "homeContainerBuilding full-screen"
            : "map-container-archilogic"
        }`}
      >
        <button className="fullscreenButton" onClick={toggleFullScreen}>
          {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </button>
       
        <div id="map" class="map_position"></div>
      </div>
      {archilogDialogData && (
        <AlisDialog
          open={showArchilogDialog}
          onClose={CloseArchilogicDialog}
          title={"Planimetry Data Expansion"}
          fields={["name", "serialNumber", "items", "protocol"]}
          dataToDisplay={archilogDialogData}
          leftButtonTitle="View More"
          leftButtonFunction={ViewMoreDetails}
        />
      )}
    </>
  );
};

export default ArchilogicMapComponent;
